var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.value.length > 0)?_c('div',{staticClass:"validation-summary"},[_c('ul',_vm._l((_vm.errors.value),function(error,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(error)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }